import { NgModule } from 'ng-metadata/core';
import { FavToggleIconComponent } from './fav-toggle-icon.component';

/**
 * @ngdoc module
 * @name mw.components.favToggle
 * @description
 *
 * Favorite Toggle
 */
@NgModule({
  declarations: [ FavToggleIconComponent ]
})

export class FavToggleModule {}



// WEBPACK FOOTER //
// ./src/lib/components/fav-toggle/fav-toggle.module.ts